import { api } from "./axios.config";
import axios from "./axios";
import { getCurrentEventId } from "../Utils/helpers";

const API_URL = api.apiUrl;
const BASE_PATH = "/event/";


export const getExhibitorTasks = (exhibitorId) => {
  const eventId = getCurrentEventId();
  return axios.get(`${API_URL}${BASE_PATH}${eventId}/exhibitors/${exhibitorId}/tasks`);
};
export const getExhibitorTasksById = (taskId) => {
  const eventId = getCurrentEventId();
  return axios.get(`${API_URL}${BASE_PATH}${eventId}/exhibitors/tasks?task_ids=${taskId}`);
};

export const getAllTasks = () => {
  const eventId = getCurrentEventId();

  return axios.get(`${API_URL}${BASE_PATH}${eventId}/exhibitors/tasks`);
};

export const getTaskAnalytics = (
  taskId,
  limit = 50,
  offset = 0,
  searchParam = "",
  taskStatus = ""
) => {
  const eventId = getCurrentEventId();

  const searchValue = searchParam ? `&search_param=${encodeURIComponent(searchParam)}` : "";

  let taskStatusQuery = "";
  if (Array.isArray(taskStatus)) {
    const validStatuses = taskStatus.filter(Boolean).join(","); 
    if (validStatuses) {
      taskStatusQuery = `&task_status=${encodeURIComponent(validStatuses)}`;
    }
  } else if (typeof taskStatus === "string" && taskStatus.trim()) {
    taskStatusQuery = `&task_status=${encodeURIComponent(taskStatus.trim())}`;
  }

  const url = `${API_URL}${BASE_PATH}${eventId}/exhibitors/tasks/${taskId}/analytics?limit=${limit}&offset=${offset}${searchValue}${taskStatusQuery}`;

  return axios.get(url);
};



export const createTask = (payload) => {
  const eventId = getCurrentEventId();
  return axios.post(API_URL + BASE_PATH + eventId + `/exhibitors/tasks`, payload);
};

export const updateTask = (taskId, payload) => {
  const eventId = getCurrentEventId();
  const url = API_URL + BASE_PATH + eventId + `/exhibitors/tasks/` + taskId;
  return axios.put(url, payload);
};

export const deleteTask = (taskId) => {
  const eventId = getCurrentEventId();
  const url = API_URL + BASE_PATH + eventId + `/exhibitors/tasks/` + taskId;
  return axios.delete(url);
};


export const updateTaskStatus = (exhibitorId, taskId, assignmentId, payload) => {
  const eventId = getCurrentEventId();
  const url = `${API_URL}${BASE_PATH}${eventId}/exhibitors/${exhibitorId}/tasks/${taskId}/${assignmentId}/status`;
  return axios.put(url, payload);
};

export const getTaskHistory = (entity,entityId) => {
  const eventId = getCurrentEventId();
  return axios.get(`${API_URL}${BASE_PATH}${eventId}/logger/entity/${entityId}`);
};
export const getTaskResponses = ({
  searchParam = "",
  taskStatus = "",
  exhibitorIds = "",
  priority = "",
  limit = 50,
  offset = 0
} = {}) => {
  const eventId = getCurrentEventId();

  const queryParams = new URLSearchParams();

  if (searchParam) queryParams.append("search_param", searchParam);
  if (taskStatus) queryParams.append("task_status", taskStatus);
  if (exhibitorIds) queryParams.append("exhibitor_ids", exhibitorIds);
  if (priority) queryParams.append("priority", priority);
  queryParams.append("limit", limit);
  queryParams.append("offset", offset);

  const url = `${API_URL}${BASE_PATH}${eventId}/tasks/responses?${queryParams.toString()}`;

  return axios.get(url);
};

